export default props=>(jsx);

const jsx=(<div className="">
<style jsx>{`
.message1{ margin: 30px 70px; }
`}</style>
    <div className="message1">
        링크가 복사되었습니다
    </div>
</div>);